import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NavbarComponent } from './components/blocks/navbar/navbar.component';
import { HeaderComponent } from './components/blocks/header/header.component';
import { FooterComponent } from './components/blocks/footer/footer.component';
import { MainComponent } from './components/pages/anwendung/main/main.component';
import { MatSpinnerOverlayComponent } from './components/elemente/mat-spinner-overlay/mat-spinner-overlay.component';
import { HilfeComponent } from './components/pages/navbar-pages/hilfe/hilfe.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErgebnisseComponent } from './components/pages/anwendung/ergebnisse/ergebnisse.component';
import { OberbegriffAkkordeonComponent } from './components/blocks/akkordeon/oberbegriff-akkordeon/oberbegriff-akkordeon.component';
import { ErgebnisAkkordeonBetriebComponent } from './components/blocks/akkordeon/ergebnis-akkordeon-betrieb/ergebnis-akkordeon-betrieb.component';
import { SonderfaelleChartComponent } from './components/blocks/charts/sonderfaelle-chart/sonderfaelle-chart.component';
import { AnteileSoChartComponent } from './components/blocks/charts/anteile-so-chart/anteile-so-chart.component';
import { DefinitionUndAnwendungsbereichComponent } from './components/pages/navbar-pages/definition-und-anwendungsbereich/definition-und-anwendungsbereich.component';
import { AbkuerzungsverzeichnisComponent } from './components/pages/navbar-pages/abkuerzungsverzeichnis/abkuerzungsverzeichnis.component';
import { LiteraturComponent } from './components/pages/navbar-pages/literatur/literatur.component';
import { PseudonymisierungCodeComponent } from './components/pages/navbar-pages/pseudonymisierungCode/pseudonymisierungCode.component';
import { PseudonymisierungVerfahrenComponent } from './components/pages/navbar-pages/pseudonymisierungVerfahren/pseudonymisierungVerfahren.component';
import { NutzungsbedingungenComponent } from './components/blocks/nutzungsbedingungen/nutzungsbedingungen.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavbarComponent,
    FooterComponent,
    HilfeComponent,
    PageNotFoundComponent,
    MainComponent,
    MatSpinnerOverlayComponent,
    ErgebnisseComponent,
    OberbegriffAkkordeonComponent,
    ErgebnisAkkordeonBetriebComponent,
    SonderfaelleChartComponent,
    AnteileSoChartComponent,
    DefinitionUndAnwendungsbereichComponent,
    LiteraturComponent,
    NutzungsbedingungenComponent,
    AbkuerzungsverzeichnisComponent,
    PseudonymisierungCodeComponent,
    PseudonymisierungVerfahrenComponent
  ],
  imports: [
	FormsModule,
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    ReactiveFormsModule
  ], 
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
